import api from "./api";

const URLS = {
  PATIENT_NAVIGATION_SETTINGS: "/patient-navigation/settings",
};

export const fetchPatientNavigationSettings = (data = {}) => {
  return api.get(URLS.PATIENT_NAVIGATION_SETTINGS, data);
};

export const fetchPatientNavigationSetting = (id: string, data = {}) => {
  return api.get(`${URLS.PATIENT_NAVIGATION_SETTINGS}/${id}`, data);
};

export const createPatientNavigationSetting = (data = {}) => {
  return api.post(URLS.PATIENT_NAVIGATION_SETTINGS, data);
};

export const updatePatientNavigationSetting = (id: string, data = {}) => {
  return api.put(`${URLS.PATIENT_NAVIGATION_SETTINGS}/${id}`, data);
};

export const activatePatientNavigationSetting = (id: string, data = {}) => {
  return api.put(`${URLS.PATIENT_NAVIGATION_SETTINGS}/${id}/activate`, data);
};

export const deactivatePatientNavigationSetting = (id: string, data = {}) => {
  return api.put(`${URLS.PATIENT_NAVIGATION_SETTINGS}/${id}/deactivate`, data);
};
